
ADILF.define('streamhub-sdk/ui/button',['require','exports','module','streamhub-ui/button'],function (require, exports, module) {module.exports = require('streamhub-ui/button');

});
